import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import RowActionsMenu from './RowActionsMenu';

const USER = { id: 7, name: 'Abe Martinez' };

const renderMenu = (props = {}) =>
  render(
    <ConfigProvider>
      <RowActionsMenu
        onRemove={jest.fn()}
        onRestore={jest.fn()}
        user={USER}
        {...props}
      />
    </ConfigProvider>,
  );

// fireEvent, not userEvent, throughout: KeyDS's Popover leaves the panel with
// `pointer-events: none` in jsdom (its popper transition never completes there),
// and userEvent refuses to click through that. Same reason FilterMenu's tests
// use fireEvent.
const openMenu = () =>
  fireEvent.click(
    screen.getByRole('button', { name: 'Actions for Abe Martinez' }),
  );

describe('management/Users RowActionsMenu', () => {
  it('names the row it acts on, so every trigger on the page differs', () => {
    renderMenu();

    expect(
      screen.getByRole('button', { name: 'Actions for Abe Martinez' }),
    ).toBeInTheDocument();
  });

  it('stays shut until asked', () => {
    renderMenu();

    expect(screen.queryByText('View Details')).not.toBeInTheDocument();
  });

  it('links View Details at the detail page', () => {
    renderMenu();
    openMenu();

    expect(screen.getByRole('menuitem', { name: /View Details/ })).toHaveAttribute(
      'href',
      '/management/users/7/edit',
    );
  });

  describe('on the current access tab', () => {
    it('offers Remove Access', () => {
      renderMenu();
      openMenu();

      expect(
        screen.getByRole('menuitem', { name: /Remove Access/ }),
      ).toBeInTheDocument();
    });

    it('does not offer Restore Access', () => {
      renderMenu();
      openMenu();

      expect(
        screen.queryByRole('menuitem', { name: /Restore Access/ }),
      ).not.toBeInTheDocument();
    });

    it('hands the row to onRemove', () => {
      const onRemove = jest.fn();
      renderMenu({ onRemove });
      openMenu();

      fireEvent.click(screen.getByRole('menuitem', { name: /Remove Access/ }));

      expect(onRemove).toHaveBeenCalledWith(USER);
    });
  });

  describe('on the removed access tab', () => {
    it('offers Restore Access instead', () => {
      renderMenu({ isRemoved: true });
      openMenu();

      expect(
        screen.getByRole('menuitem', { name: /Restore Access/ }),
      ).toBeInTheDocument();
      expect(
        screen.queryByRole('menuitem', { name: /Remove Access/ }),
      ).not.toBeInTheDocument();
    });

    it('hands the row to onRestore', () => {
      const onRestore = jest.fn();
      renderMenu({ isRemoved: true, onRestore });
      openMenu();

      fireEvent.click(screen.getByRole('menuitem', { name: /Restore Access/ }));

      expect(onRestore).toHaveBeenCalledWith(USER);
    });
  });

  // Or the modal opens behind a panel that is still painted over it.
  it('closes when an action is chosen', () => {
    renderMenu();
    openMenu();

    fireEvent.click(screen.getByRole('menuitem', { name: /Remove Access/ }));

    expect(
      screen.queryByRole('menuitem', { name: /Remove Access/ }),
    ).not.toBeInTheDocument();
  });
});
